"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("motion/react");
var _KnockRequestListItem = _interopRequireDefault(require("./KnockRequestListItem"));
var _ScreenShareKnockRequestListItem = _interopRequireDefault(require("./ScreenShareKnockRequestListItem"));
var _KnockRequestList = require("./KnockRequestList.styled");
var _PresenterRequests = require("../../../constants/PresenterRequests");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @deprecated This component is no longer in use */
var KnockRequestList = function KnockRequestList(_ref) {
  var knocks = _ref.knocks,
    unassignedCameraPresenters = _ref.unassignedCameraPresenters,
    onKnockApproved = _ref.onKnockApproved,
    onKnockRejected = _ref.onKnockRejected,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAVClicked = _ref.onAVClicked,
    liveCameras = _ref.liveCameras;
  var _knocks$length = knocks.length,
    knockCount = _knocks$length === void 0 ? 0 : _knocks$length;
  var animateKnock = knockCount === 1;
  var animation = {
    initial: {
      x: animateKnock ? -250 : 0
    },
    animate: {
      x: 0
    },
    exit: {
      x: animateKnock ? -250 : {
        opacity: 0
      }
    }
  };
  var approveKnock = function approveKnock(knock, sourceId) {
    onKnockApproved(_objectSpread(_objectSpread({}, knock), {}, {
      sourceId: sourceId
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_KnockRequestList.StyledKnockRequestBackground, null, /*#__PURE__*/_react["default"].createElement(_react2.AnimatePresence, null, knocks.map(function (knock, index) {
    var _getComponent = getComponent(knock.requestType),
      Component = _getComponent.component;
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      animation: animation,
      zIndex: 99 - index,
      key: "knock-request-item-".concat(knock.socketId)
    }, knock, {
      onApprove: function onApprove() {
        var sourceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        return approveKnock(knock, sourceId);
      },
      onReject: onKnockRejected.bind(null, knock),
      maxCamerasExceeded: maxCamerasExceeded,
      onAVClicked: onAVClicked,
      liveCameras: liveCameras,
      sources: unassignedCameraPresenters
    }));
  })));
};
KnockRequestList.propTypes = {
  knocks: _propTypes["default"].array.isRequired,
  unassignedCameraPresenters: _propTypes["default"].array,
  onKnockApproved: _propTypes["default"].func.isRequired,
  onKnockRejected: _propTypes["default"].func.isRequired,
  maxCamerasExceeded: _propTypes["default"].bool.isRequired,
  onAVClicked: _propTypes["default"].func.isRequired,
  liveCameras: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = KnockRequestList;
var requestTypeBodyComponents = (0, _defineProperty2["default"])({}, _PresenterRequests.SCREEN_SHARE_REQUEST, _ScreenShareKnockRequestListItem["default"]);
var getComponent = function getComponent(type) {
  var component = requestTypeBodyComponents[type];
  if (!component) {
    component = _KnockRequestListItem["default"];
  }
  return {
    component: component
  };
};